import { Component, EventEmitter, forwardRef, Host, Input, OnInit, Optional, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'as-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AsInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class AsInputComponent implements ControlValueAccessor, OnInit {
  @Input() label?: string;
  @Input() placeholder = '';
  @Input() type: 'text' | 'password' | 'email' | 'number' = 'text';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() customClass = '';
  @Input() formControlName: string;
  @Input() pattern: string | null;
  @Input() minlength: number | null;

  @Output() valueChange = new EventEmitter<string>();
  @Output() focusEvent = new EventEmitter<Event>();
  @Output() blurEvent = new EventEmitter<Event>();
  @Output() changeEvent = new EventEmitter<Event>();

  control: FormControl;
  value: string = '';

  onChange: (value: string) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  constructor(@Optional() @Host() private parent: FormGroupDirective) {
  }

  ngOnInit() {
    if (this.formControlName && this.parent) {
      this.control = this.parent.form.get(this.formControlName) as FormControl;
    }
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.value = inputElement.value;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
    this.changeEvent.emit(event);
  }

  onFocus(event: Event): void {
    this.focusEvent.emit(event);
  }

  onBlur(event: Event): void {
    this.onTouched();
    this.blurEvent.emit(event);
  }

  onChangeF(event: Event): void {
    this.changeEvent.emit(event);
  }
}
